import type { GeneratedSchemaKind } from '@cli-types/core-engine/add-field.js'
import type { SchemaPromptContext } from '@cli-types/next-adapter/commands.js'
import { ENTITY_SINGLE_ADD_FIELD_TYPES, FORM_ADD_FIELD_TYPES } from '@cli-constants/schema.js'
import { promptSelectValue } from './prompt-select-value.js'

export async function promptFieldType(
  context: SchemaPromptContext,
  kind: GeneratedSchemaKind
): Promise<string> {
  const types = kind === 'form' ? FORM_ADD_FIELD_TYPES : ENTITY_SINGLE_ADD_FIELD_TYPES
  return promptSelectValue(
    context,
    'Field type',
    types.map((type) => ({
      value: type,
      label: type
    }))
  )
}
